module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_j_normal.5282b10e.png";